<template>
   <div v-if="permissions">
    <wo-card :title="$t('companyUserPermission.title')">
      <wo-link v-t="'general.action.add'" @click.native.prevent="addPermission" slot="actions" />
      <po-table v-if="hasPermissions">
        <po-table-header :columns="tableColumns" slot="header" />
          <template slot="body">
            <tr v-for="permission in permissions.items" :key="permission.id">
              <td><po-route-link :value="getRoute(permission.user)" :label="permission.user.display_name" /></td>
              <td><po-display :value="permission.permission" /></td>
              <td><wo-link mod-xs mod-secondary v-t="'general.action.revoke'" @click.native.prevent="remove(permission)" /></td>
            </tr>
          </template>
        </po-table>
      <po-empty-state v-else />
      <po-paging v-model="currentPage" :data="permissions" />
    </wo-card>
  </div>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import filtered from '@/mixins/filtered'

import { ADMIN_USER } from '@/routes/admin'

import { Company } from '@/model/company'
import { companyUserPermissionRepository } from '@/repository/company'

import { showConfirmation, showModal } from '@/modal'

import CompanyUserPermissionCreateModal from '@/components/admin/CompanyUserPermissionCreateModal'

export default {
  mixins: [filtered],
  props: {
    company: Company,
    filter: Object
  },
  computed: mapState({
    permissions: state => state.company.companyUserPermissionList,
    hasPermissions () {
      return !_.isEmpty(this.permissions.items)
    },
    tableColumns () {
      return [
        { labelKey: 'companyUserPermission.user' },
        { labelKey: 'companyUserPermission.permission' },
        { width: 20 }
      ]
    }
  }),
  methods: {
    applyFilter (filter, pristine) {
      return this.$store.dispatch(companyUserPermissionRepository.findAll, { companyId: this.company.id, filter: filter, replace: !pristine })
    },
    getRoute (user) {
      return {
        name: ADMIN_USER,
        params: { userId: user.id }
      }
    },
    remove (permission) {
      const title = `${permission.permission.name} - ${permission.user.display_name}`
      showConfirmation({ title, messageKey: 'companyUserPermission.confirmDelete' }, () => {
        return this.$store.dispatch(companyUserPermissionRepository.delete, { companyId: this.company.id, entity: permission })
          .then(this.doFilter)
      })
    },
    addPermission () {
      showModal(CompanyUserPermissionCreateModal, { company: this.company })
        .then(this.doFilter)
        .catch(e => {})
    }
  }
}
</script>
